const getSyteTag = syteTitle => {
  let syteTag = ''
  if (syteTitle === 'Shop similar') {
    syteTag = 'similar_items'
  }
  if (syteTitle === 'Complete the look') {
    syteTag = 'shop_the_look'
  }
  return syteTag
}

// event sent to Syte when a 'Shop the Look' carousel is visible
const syteShopTheLookVisible = (listLength = 0) => {
  const syteDataLayerObj = {
    name: 'fe_stl_show_layout',
    tag: 'shop_the_look',
    results_count: listLength
  }
  if (listLength > 0) {
    if (typeof window !== 'undefined') {
      if (!window.syteDataLayer) {
        window.syteDataLayer = []
      }
      window.syteDataLayer.push(syteDataLayerObj)
    }
  } else {
    console.log('Error adding Syte Shop the Look visible event, invalid parameters: ', syteDataLayerObj)
  }
}

// event sent to Syte when a 'Similar items' carousel is visible
const syteSimilarItemsVisible = (listLength = 0, productSku = '', productsSkusStr = '') => {
  const syteDataLayerObj = {
    name: 'fe_si_show_layout',
    tag: 'similar_items',
    results_count: listLength,
    sku: productSku,
    skus: productsSkusStr
  }
  if (listLength > 0 && productSku && productsSkusStr) {
    if (typeof window !== 'undefined') {
      if (!window.syteDataLayer) {
        window.syteDataLayer = []
      }
      window.syteDataLayer.push(syteDataLayerObj)
    }
  } else {
    console.log('Error adding Syte Similar Items visible event, invalid parameters: ', syteDataLayerObj)
  }
}

// event sent to Syte every time a user clicks on product in a 'Similar Items' or 'Shop the Look' carousel
const syteClickEvent = (productSku = '', syteEventTag = '', positionInCarousel = 0) => {
  const syteDataLayerObj = {
    name: 'fe_offer_click',
    tag: syteEventTag,
    sku: productSku,
    position: positionInCarousel
  }
  if (productSku && syteEventTag && positionInCarousel > 0) {
    if (typeof window !== 'undefined') {
      if (!window.syteDataLayer) {
        window.syteDataLayer = []
      }
      window.syteDataLayer.push(syteDataLayerObj)
    }
  } else {
    console.log(
      'Error adding Syte click event to Similar Items or Shop the Look carousels, invalid parameters: ',
      syteDataLayerObj
    )
  }
}

export { getSyteTag, syteClickEvent, syteShopTheLookVisible, syteSimilarItemsVisible }
